import React from 'react'
import styled from 'styled-components'
import orderBy from 'lodash/orderBy'

import { FONTS } from '../../../../constants'
import { SearchSelect } from '../../../input'

export const CompanyInfoFirstCol = props => {
  const {
    _companys,
    _lobs,
    _positions,
    _departments,
    isEditMovement,
    movementData,
    handleInput,
  } = props

  const position = _positions.find(e => e._id === movementData.position_id) || null
  const company = _companys.find(e => e._id === movementData.company_id) || null
  const lob = _lobs.find(e => e._id === movementData.lob_id) || null
  const department = _departments.find(e => e._id === movementData.department_id) || null

  return (
    <FormWrapper>
      {/* <FormGroup>
        <LabelCol>
          <Label required>Company Email</Label>
        </LabelCol>
        <InputCol>
          <Input
            name='email'
            placeholder='Enter Email'
            disabled={ true }
            value={ movementData.email || '' }
          />
        </InputCol>
      </FormGroup>
      <FormGroup>
        <LabelCol>
          <Label>Employee Type</Label>
        </LabelCol>
        <InputCol>
          <SearchSelect
            name='employee_type'
            placeholder='Select Employee Type'
            value={ employee_type }
            isDisabled={ !isEditMovement }
            options={ orderBy(_employee_type, 'label', 'asc') }
            onChange={ e => handleInput(e, 'employee_type') }
          />
        </InputCol>
      </FormGroup> */}
      {/* <FormGroup>
        <LabelCol>
          <Label required>Hiring Date</Label>
        </LabelCol>
        <InputCol>
          <CustomDatePicker
            showYearDropdown
            showMonthDropdown
            autoComplete='off'
            name='hiring_date'
            placeholderText='DD/MM/YYYY'
            dateFormat='DD/MM/YYYY'
            invalid={ invalid['hiring_date'] }
            disabled={ !isEditMovement }
            selected={ movementData.hiring_date ? moment(movementData.hiring_date) : '' }
            onChange={ e => handleInput(e, 'hiring_date') }
          />
        </InputCol>
      </FormGroup> */}
      {/* <FormGroup>
        <LabelCol>
          <Label>Last Effective Date</Label>
        </LabelCol>
        <InputCol>
          <CustomDatePicker
            showYearDropdown
            showMonthDropdown
            autoComplete='off'
            name='last_effective_date'
            placeholderText='DD/MM/YYYY'
            dateFormat='DD/MM/YYYY'
            disabled={ !isEditMovement }
            selected={ movementData.last_effective_date ? moment(movementData.last_effective_date) : '' }
            onChange={ e => handleInput(e, 'last_effective_date') }
          />
        </InputCol>
      </FormGroup>
      <FormGroup>
        <LabelCol>
          <Label>Last Working Date</Label>
        </LabelCol>
        <InputCol>
          <CustomDatePicker
            showYearDropdown
            showMonthDropdown
            autoComplete='off'
            name='last_working_date'
            placeholderText='DD/MM/YYYY'
            dateFormat='DD/MM/YYYY'
            disabled={ !isEditMovement }
            selected={ movementData.last_working_date ? moment(movementData.last_working_date) : '' }
            onChange={ e => handleInput(e, 'last_working_date') }
          />
        </InputCol>
      </FormGroup> */}
      {/* <FormGroup>
        <LabelCol>
          <Label>Line Manager</Label>
        </LabelCol>
        <InputCol>
          <SearchSelect
            name='line_manager_id'
            placeholder='Select Line Manager'
            value={ line_manager }
            isDisabled={ !isEditMovement }
            options={ orderBy(users, 'label', 'asc').filter(u => u.value !== movementData.user_id) }
            onChange={ e => handleInput(e, 'line_manager_id') }
          />
        </InputCol>
      </FormGroup> */}
      <FormGroup>
        <LabelCol>
          <Label>Position</Label>
        </LabelCol>
        <InputCol>
          <SearchSelect
            name='position_id'
            placeholder='Select Position'
            value={ position }
            isDisabled={ !isEditMovement }
            options={ orderBy(_positions, 'label', 'asc') }
            onChange={ e => handleInput(e, 'position_id') }
          />
        </InputCol>
      </FormGroup>
      <FormGroup>
        <LabelCol>
          <Label>Company</Label>
        </LabelCol>
        <InputCol>
          <SearchSelect
            name='company_id'
            placeholder='Select Company'
            value={ company }
            isDisabled={ !isEditMovement }
            options={ orderBy(_companys, 'label', 'asc') }
            onChange={ e => handleInput(e, 'company_id') }
          />
        </InputCol>
      </FormGroup>
      <FormGroup>
        <LabelCol>
          <Label>LOB</Label>
        </LabelCol>
        <InputCol>
          <SearchSelect
            name='lob_id'
            placeholder='Select LOB'
            value={ lob }
            isDisabled={ !isEditMovement }
            options={ company ? orderBy(_lobs.filter(l => l.company_id === company._id), 'label', 'asc') : [] }
            onChange={ e => handleInput(e, 'lob_id') }
          />
        </InputCol>
      </FormGroup>
      <FormGroup>
        <LabelCol>
          <Label>Department</Label>
        </LabelCol>
        <InputCol>
          <SearchSelect
            name='department_id'
            placeholder='Select Department'
            value={ department }
            isDisabled={ !isEditMovement }
            options={ lob ? orderBy(_departments.filter(d => d.lob_id === lob._id), 'label', 'asc') : [] }
            onChange={ e => handleInput(e, 'department_id') }
          />
        </InputCol>
      </FormGroup>
      {/* <FormGroup>
        <LabelCol>
          <Label>Division</Label>
        </LabelCol>
        <InputCol>
          <SearchSelect
            name='division_id'
            placeholder='Select Division'
            value={ division }
            isDisabled={ !isEditMovement }
            options={ orderBy(_divisions, 'label', 'asc') }
            onChange={ e => handleInput(e, 'division_id') }
          />
        </InputCol>
      </FormGroup>
      <FormGroup>
        <LabelCol>
          <Label>Team</Label>
        </LabelCol>
        <InputCol>
          <SearchSelect
            name='team_id'
            placeholder='Select Team'
            value={ team }
            isDisabled={ !isEditMovement }
            options={ orderBy(_teams, 'label', 'asc') }
            onChange={ e => handleInput(e, 'team_id') }
          />
        </InputCol>
      </FormGroup>
      <FormGroup>
        <LabelCol>
          <Label>Level</Label>
        </LabelCol>
        <InputCol>
          <ColWrapper>
            <SearchSelect
              name='level'
              placeholder='Select Level'
              value={ level }
              isDisabled={ !isEditMovement }
              options={ orderBy(_levels, 'label', 'asc') }
              onChange={ e => handleInput(e, 'level') }
            />
            <WarningMessage>
              Changing this will be effective to all costings and pricing
            </WarningMessage>
          </ColWrapper>
        </InputCol>
      </FormGroup> */}
    </FormWrapper>
  )
}

const Label = styled.span`
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #808080;

    ${p => p.required && `
      ::after {
        content: '*';
        color: red;
      }
    `}
`

const FormWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;

    :nth-child(1) {
        padding-right: 6px;
    }

    :nth-last-child(1) {
        padding-left: 6px;
    }
`

const FormGroup = styled.div`
    display: flex;
    margin-bottom: 16px;
`

const LabelCol = styled.div`
    display: flex;
    flex: 1;
`

const InputCol = styled.div`
    display: flex;
    flex: 2;
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #808080;
`



// WEBPACK FOOTER //
// ./src/components/new-employee/edit-pane/movement-info/first-column.js